import { buildClarityDocumentPath } from './build-clarity-document-path.util';
import { isClarityUuid } from './is-clarity-uuid.util';
import type { ClarityDocumentShareTarget } from './models/clarity-document-share-target.model';

/** Ported from Clarity `apps/web/src/features/documents/utils/buildDocumentShareUrl.ts` (commit `63bab2253`). */
/**
 * An absolute deep link to an open document — brain's `buildDocumentShareUrl`:
 * `<origin>/<section>/d/<domainId>/documents?doc=<fileId>[&page=<n>]`.
 *
 * Three of their rules carry over unchanged. The path comes from {@link buildClarityDocumentPath} rather
 * than being assembled here, so the URL contract stays in one place (their TR-001). It is built against a
 * **fresh** `URLSearchParams`, never the live query, so no unowned parameter of the current page — an
 * `sd_*`, an `oi`, an `action` — rides along into a link someone else opens (their TR-002). And it reads
 * no browser global: `origin` is an argument, which is what keeps the function pure (their TR-005).
 *
 * Only the integration is adapted: brain's own path is put under `sectionPath`.
 *
 * This port's own guard: the answer is `null` when `domainId` or `fileId` is empty or not id-shaped.
 * Either would build a link the route reads back as something else — an empty domain gives
 * `/d//documents`, which parses as no domain and lands on pulse with the document dropped — so no
 * link beats a wrong one.
 */
export function buildClarityDocumentShareUrl(
	origin: string,
	sectionPath: string,
	target: ClarityDocumentShareTarget,
): string | null {
	if (!isClarityUuid(target.domainId) || !isClarityUuid(target.fileId)) {
		return null;
	}

	return `${origin}${buildClarityDocumentPath(target, sectionPath)}`;
}
